import React from 'react';

import OrderEdit from '@components/shared/orders/OrderEdit';
import { useMerchant } from '@contexts/admin/MerchantContext';
import { useMerchantData } from '@contexts/admin/MerchantDataContext';
import useOrderItemColumns from '@hooks/admin/useOrderItemColumns';
import { useParams } from 'react-router-dom';

import { orderService } from '@services/admin/orderService';
import { productService } from '@services/admin/productService';
import { contactAddressService } from '@services/admin/contactAddressService';
import bundleService from '@services/admin/bundleService';

const AdminOrderEdit = () => {
  const { id } = useParams();
  const { currentMerchant, warehouses, defaultWarehouseId, currencies } = useMerchant();
  const { salesChannels, shippingTypes, inventoryTypes, loading: merchantDataLoading } = useMerchantData();
  const { enabledColumns, availableColumns, updateColumns } = useOrderItemColumns();

  return (
    <OrderEdit
      orderService={orderService}
      productService={productService}
      contactAddressService={contactAddressService}
      role="admin"
      orderId={id}
      salesChannels={salesChannels}
      shippingTypes={shippingTypes}
      inventoryTypes={inventoryTypes}
      merchantDataLoading={merchantDataLoading}
      currentMerchantId={currentMerchant?.id}
      currencies={currencies}
      warehouseOptions={warehouses}
      defaultWarehouseId={defaultWarehouseId}
      enabledOrderItemColumns={enabledColumns}
      availableOrderItemColumns={availableColumns}
      onUpdateOrderItemColumns={updateColumns}
      bundleService={bundleService}
    />
  );
};

export default AdminOrderEdit;
